import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { FileUploadJob } from '../upload-art-modal/upload-art-modal.component';

@Component({
  selector: 'app-view-file-upload-job-modal',
  templateUrl: './view-file-upload-job-modal.component.html',
  styleUrls: ['./view-file-upload-job-modal.component.scss']
})
export class ViewFileUploadJobModalComponent {
  @Input() selectedFileUploadJob: FileUploadJob;
  isLoadingPreview = true
  finalImagePreviewWidth?: number;
  @ViewChild('imagePreview') imagePreviewRef: ElementRef;

  constructor(
    public modalRef: MdbModalRef<ViewFileUploadJobModalComponent>,
  ) {}

  onLoadPreview(event?: any): void {
    this.finalImagePreviewWidth = undefined
    this.isLoadingPreview = false
    setTimeout(() => {
      this.finalImagePreviewWidth = this.imagePreviewRef.nativeElement.offsetWidth
    }, 100)
  }

  closeModal(resp?: any) {
    this.modalRef.close(resp);
  }
}